import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { hmrBootstrap } from './app/hmr';

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

// Enables Hot Module Replacement.
declare var module: any;
if (environment.hmr) {
  if (module.hot) {
    // tslint:disable-next-line:no-console
    console.clear();
    hmrBootstrap(module, bootstrap);
  } else {
    // tslint:disable-next-line:no-console
    console.error('HMR is not enabled for webpack-dev-server!');
    // tslint:disable-next-line:no-console
    console.log('Are you using the --hmr flag for ng serve?');
  }
} else {
  bootstrap();
}
